import { render, staticRenderFns } from "./mediaList.vue?vue&type=template&id=2e082062&scoped=true"
import script from "./mediaList.vue?vue&type=script&lang=js"
export * from "./mediaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e082062",
  null
  
)

export default component.exports